import {Component, OnInit} from '@angular/core';
import {TranslationService} from "../../../../services/wrapper/translation.service";
import {BannerLayoutComponent} from "../../banner-layout.component";
import {BannerContentModel} from "../banner-content.model";
import {BsModalService} from "ngx-bootstrap";
import {NotificationService} from "../../../../services/common/notification.service";
import {MyStorageService} from "../../../../services/common/my-storage.service";

@Component({
  selector: 'app-title-content',
  templateUrl: './title-content.component.html',
  styleUrls: ['./title-content.component.scss']
})
export class TitleContentComponent extends BannerLayoutComponent<BannerContentModel> implements OnInit {
  title='';

  constructor(myStorageService:MyStorageService, translationService: TranslationService, modalService: BsModalService, notificationService: NotificationService) {
    super( translationService, modalService, notificationService, myStorageService);
  }

  ngOnInit(): void {
    this.title = this.translate(this.data.title);
  }
}
